export default "ui-point{display:none}\n";